(function (angular) {
  'use strict';
  /**
   * @ngdoc property
   * @name app.config.language
   * @requires $translateProvide
   * @description
   * Define la configuración del lenguaje
   */

  angular
    .module('bossApp')
    .config(configLanguage)

  configLanguage.$inject = ['$translateProvider', 'localeEN', 'localeES'];

  function configLanguage($translateProvider, localeEN, localeES) {
    $translateProvider.useSanitizeValueStrategy(null);
     $translateProvider.translations('en', localeEN)
     $translateProvider.translations('es', localeES)
    $translateProvider.preferredLanguage('es');
  }

})(angular);
